import { render, staticRenderFns } from "./Dropdownpoints.vue?vue&type=template&id=371ab637&scoped=true&"
import script from "./Dropdownpoints.vue?vue&type=script&lang=js&"
export * from "./Dropdownpoints.vue?vue&type=script&lang=js&"
import style0 from "./Dropdownpoints.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Dropdownpoints.vue?vue&type=style&index=1&id=371ab637&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ab637",
  null
  
)

export default component.exports